'use strict';
import React from 'react';
import BaseComponent from '../../../../shared/base';
import SearchCategoryComponent from '../../../../layouts/search-category';

class SearchComponent extends BaseComponent {
    render() {
        return <SearchCategoryComponent {...this.props} />;
    }
}

export default SearchComponent;
